export default __webpack_public_path__ + "assets/a8e4e568dfa1d49215a0652d813fc2fe.svg";